import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  month: number;
  year: number;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  month: moment().month() + 1,
  year: moment().year(),
  data: [],
};

const getListRequestLeaveSlice = createSlice({
  name: "getListRequestLeave",
  initialState,
  reducers: {
    setMonthYearListRequestLeave: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getListRequestLeaveStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListRequestLeaveSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListRequestLeaveFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    updateListRequestLeave: (state, action) => {
      state.data = action.payload;
    },
    resetListRequestLeave: () => {
      return { ...initialState };
    },
  },
});

export const {
  setMonthYearListRequestLeave,
  getListRequestLeaveStart,
  getListRequestLeaveSuccess,
  getListRequestLeaveFailed,
  resetListRequestLeave,
  updateListRequestLeave,
} = getListRequestLeaveSlice.actions;

export default getListRequestLeaveSlice.reducer;
